// @flow
'use strict';

import * as React from 'react';

import type { ICofinsStPerc } from '../../../../../types_imposto';

import RowDetalhes from '../../../../../../../common/detalhes_documento/row_detalhes';
import ColumnDetalhes from '../../../../../../../common/detalhes_documento/column_detalhes';

type CofinsStPercProps = {
  item : ICofinsStPerc,
};

export default function CofinsStPerc({ item } : CofinsStPercProps) {
  return (
      <RowDetalhes data={ item }>
        <ColumnDetalhes field="valorBc" type="moeda" width="25%">Base de Cálculo da COFINS</ColumnDetalhes>
        <ColumnDetalhes field="aliquota" type="percentual" width="25%">Alíquota da COFINS</ColumnDetalhes>
      </RowDetalhes>
  );
}
